import { mixins, Mods, mods, theme } from '@approvalmax/theme';
import { Box } from '@approvalmax/ui/src/components';
import { StyledMods } from '@styled-kit/mods';
import styled from 'styled-components';

export const Bubble = styled(Box)<StyledMods<Mods<'color'>>>`
    border-radius: ${theme.radius.xsmall};
    ${mods.color(mixins.colorTextWithBg)};
`;
